import React, { createContext, useState, useContext, useEffect } from "react";
import { getPlayerDetail } from "@/services/user";
import { cloneDeep } from "lodash-es";
import { Spin } from "antd";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
const pathList = ["/player/detail", "/player/personalCases"];

const UserContext = createContext();
let localStorageUserInfo;
try {
  localStorageUserInfo = JSON.parse(
    localStorage.getItem("uptoDate_user") || {}
  );
} catch (error) {
  localStorageUserInfo = {};
}
export const useUser = () => useContext(UserContext);
export const UserProvider = ({ children }) => {
  const location = useLocation();

  const [user, setUser] = useState(cloneDeep(localStorageUserInfo));
  const [isLoading, setLoading] = useState(false);

  const set = (userData) => {
    setUser(userData);
    localStorage.setItem("uptoDate_user", JSON.stringify(userData));
    if (!userData?.id && userData?.phone) {
      getUserInfo(userData?.phone);
    }
  };

  const getUserInfo = async (phone) => {
    setLoading(true);
    try {
      const res = await getPlayerDetail(phone);
      if (res.code === 200) {
        set(res?.result?.current || {});
      }
    } catch (error) {
      setLoading(false);
      set({});
    }
    setLoading(false);
  };

  // 当路由发生变化时，判断是否需要重新获取用户信息
  useEffect(() => {
    const pathname = location.pathname;
    if (pathList.includes(pathname)) {
      if (user?.phone) {
        getUserInfo(user?.phone);
      }
    }
  }, [location]);

  useEffect(() => {
    let userInfo;
    try {
      userInfo = JSON.parse(localStorage.getItem("uptoDate_user") || {});
    } catch (error) {
      userInfo = {};
    }
    setUser(userInfo);
    if (userInfo?.phone) {
      //  根据手机号重新获取用户信息
      getUserInfo(userInfo?.phone);
    }
  }, []);

  return (
    <Spin spinning={isLoading}>
      <UserContext.Provider value={{ user, set }}>
        {(!isLoading || (user && user?.phone)) && children}
      </UserContext.Provider>
    </Spin>
  );
};
